import { render } from "./IndexProprietaire.vue?vue&type=template&id=d4a88a4e"
import script from "./IndexProprietaire.vue?vue&type=script&lang=js"
export * from "./IndexProprietaire.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__